import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";
import Cookie from "./cookie";

import { injectStore } from "utils/axios/axiosInterceptors";
import { injectReduxStore } from "utils/_helpers/reduxGet";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/style.css";

// Create React Query client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

// Inject store into axios interceptors
injectStore(store);
injectReduxStore(store);

// Get root element and render
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
      <Cookie />
      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        newestOnTop
        pauseOnHover={false}
        draggable={false}
        theme="colored"
      />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();

// const container = document.getElementById("root");
// const root = ReactDOM.createRoot(container);

// injectStore(store);
// injectReduxStore(store);

// root.render(
//   <Provider store={store}>
//     <QueryClientProvider client={queryClient}>
//       <App />
//       <ReactQueryDevtools initialIsOpen={false} />
//       <Cookie />
//     </QueryClientProvider>
//     <ToastContainer
//       position="bottom-right"
//       autoClose={4000}
//       newestOnTop
//       pauseOnHover={false}
//       draggable={false}
//     />
//   </Provider>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
